"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaPreviousLiveCardDefaultProps = exports.DomestikaPreviousLiveCardPropTypes = exports.DomestikaPreviousLiveCard = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _Card = require("../../atoms/Card");

var _DomestikaLiveCardImage = require("../../atoms/DomestikaLiveCardImage");

var _DomestikaLiveCardInfo = require("../../atoms/DomestikaLiveCardInfo");

var _DomestikaLiveCardSkeleton = require("../../atoms/DomestikaLiveCardSkeleton");

var _Icon = require("../../atoms/Icon");

var _Icons = require("../../atoms/Icons");

var _Layout = require("../../atoms/Layout");

var _When = _interopRequireDefault(require("../../utils/When"));

var _withTooltip = require("../../HOC/withTooltip");

var _hooks = require("../../utils/hooks");

var _validate = require("./validate");

var StyledCardWrapper = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaPreviousLiveCard__StyledCardWrapper",
  componentId: "sc-1bwqpva-0"
})({
  flexDirection: 'column',
  overflow: 'hidden',
  cursor: 'pointer'
}, (0, _styledSystem.variant)({
  prop: 'loading',
  variants: {
    true: {
      cursor: 'default'
    }
  }
}));
var StyledCard = (0, _styledComponents.default)(_Card.Card).withConfig({
  displayName: "DomestikaPreviousLiveCard__StyledCard",
  componentId: "sc-1bwqpva-1"
})({
  padding: '0'
}, (0, _css.default)({
  height: ['195px', '233px', '197px', '257px'],
  borderRadius: 4
}), (0, _styledSystem.variant)({
  prop: 'loading',
  variants: {
    true: {
      backgroundColor: 'durian'
    }
  }
}));
var StyledHover = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaPreviousLiveCard__StyledHover",
  componentId: "sc-1bwqpva-2"
})({
  width: '100%',
  height: '100%',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  transition: 'background-color .2s linear',
  backgroundColor: 'transparent',
  zIndex: 20,
  float: 'left'
}, (0, _css.default)({
  padding: 4,
  borderRadius: 4,
  ':hover': {
    backgroundColor: 'ghosted.sonar.dark'
  }
}));
var StyledIconWrapper = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaPreviousLiveCard__StyledIconWrapper",
  componentId: "sc-1bwqpva-3"
})({
  cursor: 'default',
  padding: '6px'
}, (0, _styledSystem.variant)({
  prop: 'rounded',
  variants: {
    true: {
      borderRadius: '50%'
    }
  }
}));
var StyledIcon = (0, _styledComponents.default)(_Icon.IconForm).withConfig({
  displayName: "DomestikaPreviousLiveCard__StyledIcon",
  componentId: "sc-1bwqpva-4"
})({
  fontSize: '20px',
  lineHeight: '20px'
});

var LockIcon = function LockIcon(props) {
  return _react.default.createElement(StyledIconWrapper, (0, _extends2.default)({
    backgroundColor: "coco",
    rounded: true
  }, props), _react.default.createElement(StyledIcon, null, _react.default.createElement(_Icons.Lock, null)));
};

var StudentIcon = function StudentIcon(props) {
  return _react.default.createElement(StyledIconWrapper, (0, _extends2.default)({
    backgroundColor: "coco",
    rounded: true
  }, props), _react.default.createElement(StyledIcon, null, _react.default.createElement(_Icons.Cap, null)));
};

var DomestikaPreviousLiveCard = function DomestikaPreviousLiveCard(_ref) {
  var streamers = _ref.streamers,
      liveInfo = _ref.liveInfo,
      loading = _ref.loading,
      locked = _ref.locked,
      lockedTooltip = _ref.lockedTooltip,
      student = _ref.student,
      studentTooltip = _ref.studentTooltip,
      onClick = _ref.onClick,
      observerRootElement = _ref.observerRootElement,
      lazyLoading = _ref.lazyLoading,
      width = _ref.width,
      height = _ref.height;

  if (!loading) {
    (0, _validate.validate)({
      streamers: streamers,
      liveInfo: liveInfo,
      onClick: onClick
    });
  }

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      bottomIcon = _useState2[0],
      setBottomIcon = _useState2[1];

  var _useLazyLoadElement = (0, _hooks.useLazyLoadElement)({
    lazyLoading: lazyLoading,
    rootElement: observerRootElement,
    rootMargin: '0px'
  }),
      isElementVisible = _useLazyLoadElement.isElementVisible,
      getElementRef = _useLazyLoadElement.getElementRef;

  var isLoadingState = function isLoadingState() {
    return loading || !isElementVisible;
  };

  (0, _react.useEffect)(function () {
    if (locked) {
      setBottomIcon(function () {
        return (0, _withTooltip.WithTooltip)(LockIcon, {
          position: 'left',
          message: lockedTooltip,
          id: 'dmstk-previous-live-lock-icon-tooltip'
        });
      });
    } else if (student) {
      setBottomIcon(function () {
        return (0, _withTooltip.WithTooltip)(StudentIcon, {
          position: 'left',
          message: studentTooltip,
          id: 'dmstk-previous-live-student-icon-tooltip'
        });
      });
    } else {
      setBottomIcon(null);
    }
  }, [locked, student]);
  return _react.default.createElement("div", {
    ref: getElementRef
  }, _react.default.createElement(StyledCardWrapper, {
    onClick: onClick,
    width: width,
    height: height
  }, _react.default.createElement(StyledCard, {
    loading: isLoadingState() ? 'true' : 'false'
  }, _react.default.createElement(_When.default, {
    condition: !isLoadingState()
  }, function () {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_DomestikaLiveCardImage.DomestikaLiveCardImage, {
      imageUrl: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.coverUrl,
      lazyLoading: lazyLoading
    }), _react.default.createElement(StyledHover, null, _react.default.createElement(_When.default, {
      condition: !!bottomIcon
    }, function () {
      return _react.default.createElement(_react.default.Fragment, null, bottomIcon());
    })));
  })), _react.default.createElement(_Layout.Flex, {
    width: "100%",
    paddingTop: 4
  }, _react.default.createElement(_When.default, {
    condition: !!isLoadingState()
  }, function () {
    return _react.default.createElement(_DomestikaLiveCardSkeleton.DomestikaLiveCardSkeleton, {
      type: "complete",
      color: "durian"
    });
  }), _react.default.createElement(_When.default, {
    condition: !isLoadingState()
  }, function () {
    return _react.default.createElement(_DomestikaLiveCardInfo.DomestikaLiveCardInfo, {
      liveInfo: liveInfo,
      streamers: streamers,
      size: "medium",
      fontColor: "dark",
      maxLines: 3
    });
  }))));
};

exports.DomestikaPreviousLiveCard = DomestikaPreviousLiveCard;
var DomestikaPreviousLiveCardPropTypes = {
  streamers: _propTypes.default.arrayOf(_propTypes.default.shape({
    avatar: _propTypes.default.string,
    name: _propTypes.default.string
  })),
  liveInfo: _propTypes.default.shape({
    scheduledAt: _propTypes.default.string,
    language: _propTypes.default.string,
    title: _propTypes.default.string,
    coverUrl: _propTypes.default.string
  }),
  loading: _propTypes.default.bool,
  locked: _propTypes.default.bool,
  lockedTooltip: _propTypes.default.string,
  student: _propTypes.default.bool,
  studentTooltip: _propTypes.default.string,
  onClick: _propTypes.default.func,
  lazyLoading: _propTypes.default.bool,
  observerRootElement: _propTypes.default.node,
  width: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string])
};
exports.DomestikaPreviousLiveCardPropTypes = DomestikaPreviousLiveCardPropTypes;
var DomestikaPreviousLiveCardDefaultProps = {
  streamers: null,
  liveInfo: null,
  loading: false,
  locked: false,
  lockedTooltip: '',
  student: false,
  studentTooltip: '',
  onClick: null,
  lazyLoading: false,
  observerRootElement: null,
  width: ['100%', '350px', '296px', '388px'],
  height: 'auto'
};
exports.DomestikaPreviousLiveCardDefaultProps = DomestikaPreviousLiveCardDefaultProps;
DomestikaPreviousLiveCard.defaultProps = DomestikaPreviousLiveCardDefaultProps;